import React from "react";

const PDFViewer = () => {
  const pdfUrl = "https://yupup-media.s3.amazonaws.com/services/Benefits.pdf";

  return (
    <div>
      <iframe title="PDF Viewer" src={pdfUrl} width="100%" height="1000" />
    </div>
  );
};

export default PDFViewer;
